import React, { ReactElement } from "react";
import MainBanner from "@components/payrollsystems/mainBanner";
import { GetServerSideProps } from "next";
import dynamic from "next/dynamic";
import { getPageProps } from "@services/initial-calls";
import { useDomainContext } from "@hooks/useDomainContext";
import PayrollSystemsWrapper from "@components/layouts/payrollSystemsWrapper";
const OffersList = dynamic(() => import("@components/shared/offersList"));

const WhyUs = dynamic(() => import("@components/payrollsystems/whyUs"));

export default function PayrollSystemsHome(): ReactElement {
    const { domain } = useDomainContext();

    return (
        <PayrollSystemsWrapper>
            <MainBanner />
            <section>
                <OffersList offers={domain?.defaultOffers} />
            </section>
            <WhyUs />
        </PayrollSystemsWrapper>
    );
}

export const getServerSideProps: GetServerSideProps = async (context) => {
    return await getPageProps(context, "home");
};
